module.exports = __webpack_public_path__ + "media/images/slider/Boiled-Fish-in-chili-oil-db823419f7f91cbebb91eae0b22c1240.jpg";